import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';
import { MeshPhysicalMaterial } from 'three';
import { useFrame } from '@react-three/fiber';
import distort from '../helpers/glsl/distort.vert.glsl.js';

var DistortMaterialImpl = /*#__PURE__*/function (_MeshPhysicalMaterial) {
  _inherits(DistortMaterialImpl, _MeshPhysicalMaterial);

  var _super = _createSuper(DistortMaterialImpl);

  function DistortMaterialImpl() {
    var _this;

    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, DistortMaterialImpl);

    _this = _super.call(this, parameters);

    _this.setValues(parameters);

    _this._time = {
      value: 0
    };
    _this._distort = {
      value: 0.4
    };
    _this._radius = {
      value: 1
    };
    return _this;
  }

  _createClass(DistortMaterialImpl, [{
    key: "onBeforeCompile",
    value: function onBeforeCompile(shader) {
      shader.uniforms.time = this._time;
      shader.uniforms.radius = this._radius;
      shader.uniforms.distort = this._distort;
      shader.vertexShader = "\n      uniform float time;\n      uniform float radius;\n      uniform float distort;\n      ".concat(distort, "\n      ").concat(shader.vertexShader, "\n    ");
      shader.vertexShader = shader.vertexShader.replace('#include <begin_vertex>', "\n        float updateTime = time / 50.0;\n        float noise = snoise(vec3(position / 2.0 + updateTime * 5.0));\n        vec3 transformed = vec3(position * (noise * pow(distort, 2.0) + radius));\n        ");
    }
  }, {
    key: "time",
    get: function get() {
      return this._time.value;
    },
    set: function set(v) {
      this._time.value = v;
    }
  }, {
    key: "distort",
    get: function get() {
      return this._distort.value;
    },
    set: function set(v) {
      this._distort.value = v;
    }
  }, {
    key: "radius",
    get: function get() {
      return this._radius.value;
    },
    set: function set(v) {
      this._radius.value = v;
    }
  }]);

  return DistortMaterialImpl;
}(MeshPhysicalMaterial);

var MeshDistortMaterial = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? 1 : _ref$speed,
      props = _objectWithoutProperties(_ref, ["speed"]);

  var _React$useState = React.useState(function () {
    return new DistortMaterialImpl();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      material = _React$useState2[0];

  useFrame(function (state) {
    return material && (material.time = state.clock.getElapsedTime() * speed);
  });
  return /*#__PURE__*/React.createElement("primitive", _extends({
    dispose: undefined,
    object: material,
    ref: ref,
    attach: "material"
  }, props));
});
export { MeshDistortMaterial };